import React, { useContext, useState } from "react";
import { colors } from "../../assets/colors";
import { WebrtcContext } from "../../modules/Webrtc";
import {
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  ArrowBackOutlined,
  DesktopWindowsOutlined,
} from "@mui/icons-material";
import TripOriginRoundedIcon from "@mui/icons-material/TripOriginRounded";

const SideComponent = ({ openD, toggleOpenDrawer, currentWiidth }: any) => {
  const {
    peers,
    handlePlayStream,
    handleStopStream,
    streamActiveListe,
    setCurrentVideo,
    handleAddActiveStream,
  } = useContext(WebrtcContext);

  const [openStates, setOpenStates] = useState<Array<boolean>>(
    Array(peers.length).fill(true)
  );

  const handleClick = (index: number) => {
    setOpenStates((prevState) => {
      const newState = [...prevState];
      newState[index] = !prevState[index];
      return newState;
    });
  };

  const SlideBody = () => (
    <div>
      {peers?.map((el: any, key: number) => (
        <div key={"_elm_" + key}>
          <ListItemButton onClick={() => handleClick(key)}>
            <ListItemIcon>
              <TripOriginRoundedIcon style={{ color: "white" }} />
            </ListItemIcon>
            <ListItemText primary={el?.email?.split("@")[0]} />
            {openStates[key] ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={true} timeout="auto" unmountOnExit>
            {el.streams?.map((ee: string, kk: number) => (
              <List key={"_list_k_" + kk} component="div" disablePadding>
                <ListItem
                  secondaryAction={
                    <div>
                      {streamActiveListe.find(
                        (i: any) => i.streamName === ee
                      ) && (
                        <DesktopWindowsOutlined
                          fontSize="small"
                          style={{ color: "green", marginTop: 5 }}
                        />
                      )}
                    </div>
                  }
                >
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={async () => {
                      const isCurr = streamActiveListe.find(
                        (i: any) => i.streamName === ee
                      );

                      if (isCurr) {
                        await handleStopStream(el.clientid, ee);

                        if ([...streamActiveListe]?.length) {
                          handleAddActiveStream(streamActiveListe[0]);
                        } else handleAddActiveStream({});
                      } else {
                        setCurrentVideo({ id: el.clientid, name: ee });
                        handlePlayStream(el.clientid, ee);
                        // handleAddActiveStream(isCurr);
                      }
                    }}
                  >
                    <ListItemIcon>
                      <TripOriginRoundedIcon style={{ color: "white" }} />
                    </ListItemIcon>
                    <ListItemText primary={ee.split("@")[0]} />
                  </ListItemButton>
                </ListItem>
              </List>
            ))}
          </Collapse>
        </div>
      ))}
    </div>
  );
  return (
    <>
      <div
        className="aside-nav"
        style={{
          display: currentWiidth > 980 ? "block" : "none",
          width: "20%",
          minWidth: 210,
          backgroundColor: colors.green,
          height: "100vh",
          position: "fixed",
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          paddingTop: 48,
          marginTop: 16,
          zIndex: 2,
        }}
      >
        <SlideBody />
      </div>

      <Drawer
        anchor="left"
        PaperProps={{
          sx: {
            backgroundColor: colors.green,
            color: "white",
          },
        }}
        open={openD}
        onClose={() => {
          toggleOpenDrawer();
        }}
      >
        <div style={{ height: 50 }}>
          <IconButton
            onClick={() => {
              toggleOpenDrawer();
            }}
            color="inherit"
            aria-label="add an alarm"
            style={{ position: "absolute", left: 10, padding: 10, top: 5 }}
          >
            <ArrowBackOutlined />
          </IconButton>
        </div>
        <SlideBody />
      </Drawer>
    </>
  );
};

export default SideComponent;
